const API_URL = window.origin;

export const environment = {
  production: false,
  dev: true,
  hmr: false,
  qa: false,
  appClientID: '2046705e-c704-48cf-aef9-e52362fc898a',
  appTenantID:'e9193073-ba8b-4e38-8647-ba6687270821',
  loginRedirectUriAD: API_URL,
  logoutRedirectUriAD: API_URL,
  apiUrl: `${API_URL}`,
  localUrl: null,
  securityApiUrl: `${API_URL}/auth`,
  commonApiUrl: `${API_URL}/common`,
  repositoriesApiUrl:`${API_URL}/repositories`,
  innovationApiUrl:`${API_URL}/innovation`,
  marketApiUrl:`${API_URL}/market`,
  bpmApiUrl: `${API_URL}/bpm`,
  rayfinApiUrl: `${API_URL}/rayfin`,
  legalApiUrl:`${API_URL}/legal`,
  rydApiUrl:`${API_URL}/ryd`,
  azureApiUrl:`${API_URL}/azure`,
  sharepointApiUrl:`${API_URL}/sharepoint-integration`,
  pdcaUrl: `${API_URL}/pdca`,
  agents: {
    bryant: {
      url: `https://beliv-apirest-agent-qa.mangograss-1385da8d.eastus2.azurecontainerapps.io/api`,
      id: '2d783001-249e-498e-bef9-a9a29720da20'
    },
    // Agentes entre los que se puede elegir en el chat. Con uno solo (o
    // ninguno) no se dibuja el selector y se usa `bryant`.
    bryantOptions: [
      { key: 'dev', label: 'DEV', url: `https://beliv-apirest-agent-dev.greenriver-5d909f66.eastus2.azurecontainerapps.io/api`, id: '85057db5-d1ea-4e86-a547-486c0ef52630' },
      { key: 'qa', label: 'QA', url: `https://beliv-apirest-agent-qa.mangograss-1385da8d.eastus2.azurecontainerapps.io/api`, id: '2d783001-249e-498e-bef9-a9a29720da20' }
    ]
  },
  services: {
    applicationInsights: 'bf5b547c-0365-4807-9b62-db0cb348a06f',
    hcaptcha:{
      siteKey: '36a4be27-8cbb-4cf7-98e7-0f67d1a42297',
      languageCode: 'es'
    },
    sweepbot: {
      url: 'https://beliv-apirest-sharepoint-int-dev.greenriver-5d909f66.eastus2.azurecontainerapps.io',
    }
  },
  projects: {
    Dashboard: 'Dashboard',
    Home: 'Inicio',
    EmbeddedSite: 'Sitios Incrustados',
    Belivpedia: 'Belivpedia',
    InnovationTank: 'Tanque de Innovaciones',
    PriceList: 'Tarifario',
    BrandRegister: 'Registro de Marcas',
    Comex: 'Comex',
    NonCompesteMap: 'Mapa Non Competes',
    Suppliers: 'Proveedores',
    Formulas: "Formulas",
    Ingredients: 'Ingredientes',
    Products: 'Productos',
    ProductCategory: 'Categorias de Productos',
    Package: 'Empaques',
    PackageType: 'Tipos de Empaques',
    Brand: 'Marcas',
    Flavor: 'Sabores',
    CapType: 'Tipos de Tapas',
    Bix: 'Bryant',
    AiRegistry: 'Catálogo de IA',
    Regulations: 'Regulaciones',
    ProductRegulations: 'Seguimiento Regulatorio',
    PDCA: 'PDCA',
    Headquarters: 'Headquarters',
    Search: 'Buscador',
    Layout: 'Layout',
    Bpm: 'BPM',
    BusinessUnit: 'Unidades de Negocio',
    Company: 'Compañías',
    Groups: 'Grupos',
    FileManager: 'Gestor de Archivos',
    Menus: 'Menús',
    Modules: 'Módulos',
    News: 'Noticias',
    Roles: 'Roles',
    Certifications: 'Certificaciones',
    Density: 'Densidades',
    Functionalities: 'Funcionalidades',
    Strategies: 'Estrategias',
    TechnologicalFunctions: 'Funciones Tecnológicas',
    Tags: 'Etiquetas',
    Users: 'Usuarios',
    SharepointGrant: 'Integración SharePoint',
    Reports: 'Reportes',
    StatusChange: 'Cambios de Estado',
    // Inicio de sesión y renovación del token con Entra ID
    Login: 'Login'
  },
  sharepointConfig: {
    id: '3e2ac4d7-98c8-4563-ac14-95444fb854b2',
    name: 'Beliv Sharepoint Manager'
  }
};
